const HASHTABLE_ITADVISORS_PARTNER_NAMES = ['hashtable srl - itadvisors app'];

export function isHashtableItadvisorsPartner(partnerName?: string | null): boolean {
  return HASHTABLE_ITADVISORS_PARTNER_NAMES.includes(partnerName?.toLowerCase() ?? '');
}
